import http from "./http-common";

class PhraseService { 
  async getAll() {       
   const respons= await http.get(`Phrase/GetAll`);    
    return respons
  }   
}

export default new PhraseService();